<template>
  <!-- <transition name="animated" enter-active-class="animated fadeIn">
  </transition> -->
    <v-btn v-show="visible" class="spinner" icon small><v-icon size="16" >mdi-cog</v-icon></v-btn>
</template>

<script>
import appSettings from "@/_mixins/app-settings-mixin"
export default {
  name: 'WorkingIndicator',
  mixins : [appSettings],
  components: {},
  mounted()
  {
  },
  computed : {
    visible()
    {
      return this.globalWorkQueue.length > 0
    }
  },
  data()
  {
    return {

    }
  },
  methods : {
  }
}
</script>

<style scoped lang="scss">
.spinner {
    opacity:1;
    // position: fixed;
    // top: 97vh;
    // left: 9vh;
    // width: 120px;
    // height: 120px;
    // margin:-60px 0 0 -60px;
    -webkit-animation:spin 4s linear infinite;
    -moz-animation:spin 4s linear infinite;
    animation:spin 4s linear infinite;
}
@-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
@-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
@keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }
</style>
